export const Brands = [
    {
        title: "Freeman Jones",
        contactUsLink: 'https://www.financialwellnessgroup.co.uk/contact-us/'
    }
];

export interface UploadFileDetails {
    file: File | null;
    ni: string;
    wageSlipDate: string;
    netPay: string;
}

export interface AccountNumberReq {
    accountNumber: string;
    uuid: string;
    token: string;
    lastName: string;
    dateOfBirth: string;
    postcode: string;
    fileTye: string;
    creditorDocType: string;
    incomeDocType: string;
    carhpDocType: string;
    IncomeExpenditureDocType: string;
    OffsetEvidenceDocType: string;
    PropertyDocType: string;
    VariationDocType: string;
    OtherDocType: string;
    uploadDetails: UploadFileDetails[];
}

export type AppContextType = {
    accountNumberReq: AccountNumberReq;
    setAccountNumberReq: (accountNumberReq: AccountNumberReq) => void;
}

export const UPLOAD_DOC_TYPES = [
    { type: "INCOME", heading: "Proof of Income", description: "Wage slips, P60. P45, tax returns, Benefits, Redundancy, Bank Statements", css: 'form__radio' },
    { type: "OFFSET_EVIDENCE", heading: "Offset Evidence", description: "Documents to help reduce your additional monies", css: 'form__radio' },
    { type: "INCOME_EXPENDITURE", heading: "Income and Expenditure", description: "Your latest Income and Expenditure document & supporting evidence (bills etc)", css: 'form__radio' },
    { type: "CREDITOR", heading: "Creditor Post", description: "Letters you have received from your creditors", css: 'form__radio__2' },
    { type: "CAR_HP_DOCUMENTS", heading: "Car Finance Documents", description: "Documents we have requested relating to a car finance approval", css: 'form__radio__2r5' },
    { type: "PROPERTY_DOCUMENTS", heading: "Property Documents", description: "Documents relating to your Mortgaged property (if you have one)", css: 'form__radio__2r5' },
    { type: "VARIATION", heading: "Variation Documents", description: "Documents to help arrange a meeting with your creditors", css: 'form__radio__2r5' },
    { type: "OTHERS", heading: "Anything unrelated to the above", description: "Only use this if no other category is suitable", css: 'form__radio__2' }
];

export const CREDITOR_FILE_TYPES = [
    { type: "DEBIT", heading: "Additional Debt", description: "Proof of a debt that you don't believe is included already within your arrangement", css: 'form__radio' },
    { type: "LETTER", heading: "General Letter / Default Letter", description: "A general letter from a creditor you have received (that we already know about)", css: 'form__radio' },
    { type: "PPI", heading: "PPI Document", description: "Letters relating to PPI - includes any Claim Management documents you have received", css: 'form__radio' }
];

export const INCOME_FILE_TYPES = [
    { type: "WAGE", heading: "Wage slips", description: "Wage slips you have received from your employer", css: 'form__radio__2' },
    { type: "P60_HMRC", heading: "P60", description: "The end of year document summarising your earnings for the financial year", css: 'form__radio__3' },
    { type: "P45", heading: "P45", description: "Proof that your job has come to an end", css: 'form__radio__2' },
    { type: "SELF_ASSESSMENT", heading: "Self Assessment/Tax Return", description: "Your Tax Return or self Assessment received from HMRC or accountant", css: 'form__radio__3' },
    { type: "BENEFITS", heading: "Benefits", description: "Proof of your benefit income, including Universal Credit etc.", css: 'form__radio__2r5' },
    { type: "INCOME_PROOF", heading: "Redundancy", description: "Evidence of your Redundancy Payslip or Letter", css: 'form__radio__2' },
    { type: "BANK_STATEMENTS", heading: "Bank Statements/Other", description: "Any other income you may receive that you wish to display to us", css: 'form__radio__2r5' },
    { type: "HMRC_TAXABLE_INCOME", heading: "HMRC Taxable Income", description: "A document summarising your earnings for the financial year directly from HMRC", css: 'form__radio__2r5' }
];

export const OFFSET_EVIDENCE_FILE_TYPES = [
    { type: "REGULAR_BILLS", heading: "Regular Bills", description: "Evidence of changes to your fixed costs that include your name/date/value", css: 'form__radio__2r5' },
    { type: "BENEFIT_CHANGES", heading: "Benefit changes", description: "Evidence of changes to your benefits that include your name/date/value", css: 'form__radio__3' },
    { type: "ONE_OFF_CHARGE", heading: "One off charge/cost", description: "Receipts proving essential expenditure (e.g. Car Repairs)", css: 'form__radio__2' },
    { type: "OFFSET_BANK_STATEMENT", heading: "Bank Statement", description: "Make sure any figures we need to consider are highlighted", css: 'form__radio__3' }
];

export const INCOME_EXPENDITURE_FILE_TYPES = [
    { type: "INCOME_EXPENDITURE_FORM", heading: "Income & Expenditure Form", description: "A picture of a form we have sent to you (if you haven't used our online form)", css: 'form__radio__2' },
    { type: "PROOF_OF_INCOME_CHANGES", heading: "Proof of income Changes", description: "Evidence to support changes to your income", css: 'form__radio__3' },
    { type: "PROOF_OF_EXPENDITURE_CHANGES", heading: "Proof of Expenditure Changes", description: "Evidence to support changes to your expenditure", css: 'form__radio__2' }
];

export const CAR_HP_DOCUMENTS_FILE_TYPES = [
    { type: "CAR_INCOME_EXPENDITURE_FORM", heading: "Income & Expenditure Form", description: "A picture of a form we have sent to you (if you haven't used our online form)", css: 'form__radio__2' },
    { type: "CAR_PROOF_OF_INCOME_CHANGES", heading: "Proof of income Changes", description: "Evidence to support changes to your income", css: 'form__radio__3' },
    { type: "CAR_PROOF_OF_EXPENDITURE_CHANGES", heading: "Proof of Expenditure Changes", description: "Evidence to support changes to your expenditure", css: 'form__radio__2' },
    { type: "CAR_FINANCE_APPROVAL_FORM", heading: "Car finance approval form", description: "An approval form sent to you by the lender", css: 'form__radio__2' }
];

export const PROPERTY_DOCUMENTS_FILE_TYPES = [
    { type: "MORTGAGE_STATEMENT", heading: "Mortgage Statement", description: "Your latest statement - make sure this is dated within the last 12 months", css: 'form__radio__2' },
    { type: "SECURED_LOAN_STATEMENT", heading: "Secured Loan Statement", description: "Your latest statement - make sure this is dated within the last 12 months", css: 'form__radio__3' },
    { type: "ATTEMPT_TO_REMORTGAGE", heading: "Attempt to remortgage", description: "Evidence of you attempting to release equity", css: 'form__radio__2' },
    { type: "VALUATION", heading: "Valuation", description: "Evidence of the property valuation", css: 'form__radio__2' },
    { type: "SALE_OF_PROPERTY", heading: "Sale of Property", description: "Documents from a solicitor regarding the sale of your property", css: 'form__radio__2' }
];

export const VARIATION_FILE_TYPES = [
    { type: "OFFER_LETTER", heading: "Offer Letter", description: "A signed letter showing your proposal to your creditors (e.g. You are offering a lump sum of £x)", css: 'form__radio__2' },
    { type: "PROOF_OF_FUNDS", heading: "Proof of Funds", description: "Evidence of the source of any funds", css: 'form__radio__3' },
    { type: "IDENTIFICATION", heading: "Identification (ID)", description: "Copy of photographic ID", css: 'form__radio__2' },
    { type: "GENERAL_EVIDENCE", heading: "General Evidence (e.g. Medical)", description: "Any documents you wish to send to us to support your offer to creditors", css: 'form__radio__2' },
    { type: "ADDITIONAL_INFORMATION", heading: "Additional information", description: "Anything else you wish to share with us", css: 'form__radio__2' }
];

export const OTHERS_FILE_TYPES = [
    { type: "OTHER_CLASSIFIED_DOC", heading: "Other unclassified document", description: "Any ad hoc documents you wish to send to us", css: 'form__radio__2' },
    { type: "OTHER_CHANGE_OF_NAME", heading: "Change of name/ID", description: "Copy of photographic ID", css: 'form__radio__3' },
    { type: "OTHER_CHANGE_OF_ADDRESS", heading: "Change of address", description: "Utility/Council Tax bill or Tenancy Agreement to support a change to a new address", css: 'form__radio__2' },
    { type: "OTHER_MEDIFICATION_EVIDENCE", heading: "Modification evidence", description: "Evidence to satisfy the amended terms", css: 'form__radio__2' },
    { type: "OTHER_PAYMENT_HOLIDAY_EVIDENCE", heading: "Payment holiday evidence", description: "Evidence to support your request", css: 'form__radio__2' },
    { type: "OTHER_APP_QUERY", heading: "App query", description: "Any screenshots of messages you wish to query", css: 'form__radio__2' }
];